import React, { Component } from 'react'
import Page from 'components/Page'

import Login from 'features/Auth/Login'
import sLay from 'styles/modules/layout.scss'

export default class LoginPage extends Component {
  render() {
    return (
      <Page title="Login" className={sLay['layout-column']}>
        <Login />
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/pages/Login/Login.jsx